import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-601bc092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "k-h4 k-opacity-20 k-font-bold responsive-class" }, "Exclude users from dashboard report", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-d-inline-block" }, "Select users to exclude. The search returns only the first 20 results. If you don't see the email you're looking for, try searching again.", -1))
const _hoisted_4 = { class: "interact-container" }
const _hoisted_5 = { class: "exclude-input" }
const _hoisted_6 = { ref: "excludeUserInput" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_8 = { ref: "excludedUsersGrid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KMultiselect = _resolveComponent("KMultiselect")!
  const _component_KButton = _resolveComponent("KButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, null, 512),
        _createElementVNode("div", null, [
          _createVNode(_component_KMultiselect, {
            id: "excludeDashboardGroups",
            "data-items": _ctx.dashboardGroupTypes,
            placeholder: 'Select dashboard group types',
            modelValue: _ctx.multiselectValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.multiselectValue) = $event))
          }, null, 8, ["data-items", "modelValue"])
        ]),
        _createVNode(_component_KButton, { onClick: _ctx.onSaveClick }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_8, null, 512)
    ])
  ]))
}